import inventoryApi from "@/api/inventory";

const state = {
    items: [],
    totalHas: 0,
    jewelryItems: [],
    jewelryTotalHas: 0,
};

const getters = {
    items: state => state.items,
    totalHas: state => state.totalHas,
    jewelryItems: state => state.jewelryItems,
    jewelryTotalHas: state => state.jewelryTotalHas,
};

const actions = {
    getInventoryItems: async (context, type) => {
        const d = (await inventoryApi.getInventoryItems(type)).data;
        context.commit("setItems", d);
        return d;
    },
    getTotalHas: async (context) => {
        const d = (await inventoryApi.getTotalHas()).data;
        context.commit("setTotalHas", d);
        return d;
    },
    addKulce: async (context, dto) => {
        const d = (await inventoryApi.addKulce(dto)).data;
        return d;
    },
    addZiynet: async (context, dto) => {
        const d = (await inventoryApi.addZiynet(dto)).data;
        return d;
    },
    addDiger: async (context, dto) => (await inventoryApi.addDiger(dto)).data,
    addTaki: async (context, dto) => {
        const d = (await inventoryApi.addTaki(dto)).data;
        return d;
    },
    getJewelryItems: async (context, { status, search, size, weightRounded, purity, productName } = {}) => {
        const d = (await inventoryApi.getJewelryItems(status, search, size, weightRounded, purity, productName)).data;
        context.commit("setJewelryItems", d);
        return d;
    },
    getJewelryTotalHas: async (context, { status, size, weightRounded, purity, productName } = {}) => {
        const d = (await inventoryApi.getJewelryTotalHas(status, size, weightRounded, purity, productName)).data;
        context.commit("setJewelryTotalHas", d);
        return d;
    },
    deleteJewelryItem: async (context, id) => {
        await inventoryApi.deleteJewelryItem(id);
    },
    updateJewelryStatus: async (context, { id, dto }) => {
        await inventoryApi.updateJewelryStatus(id, dto);
    },

    // Tedarikçi alım mutabakatı
    getSupplierIntakeSummary: async (context, params) => (await inventoryApi.getSupplierIntakeSummary(params)).data,
    getSupplierIntakeMovements: async (context, params) => (await inventoryApi.getSupplierIntakeMovements(params)).data,
    getOpenSupplierIntakes: async (context, { supplierType, supplierId }) => (await inventoryApi.getOpenSupplierIntakes(supplierType, supplierId)).data,
    getCanViewSupplierIntakeReconciliation: async () => (await inventoryApi.getCanViewSupplierIntakeReconciliation()).data,
    closeSupplierIntake: async (context, { supplierType, id, note }) => (await inventoryApi.closeSupplierIntake(supplierType, id, note)).data,
    reopenSupplierIntake: async (context, { supplierType, id, note }) => (await inventoryApi.reopenSupplierIntake(supplierType, id, note)).data,
    receiveIntake: async (context, dto) => (await inventoryApi.receiveIntake(dto)).data,
    undoReceiveIntake: async (context, { batchId, note }) => (await inventoryApi.undoReceiveIntake(batchId, note)).data,
    getReconciliationHistory: async (context, params) => (await inventoryApi.getReconciliationHistory(params)).data,
    getSupplierIntakeReconciliation: async (context, params) => (await inventoryApi.getSupplierIntakeReconciliation(params)).data,

    // Zimmet
    zimmetAssign: async (context, dto) => (await inventoryApi.zimmetAssign(dto)).data,
    zimmetReturn: async (context, dto) => (await inventoryApi.zimmetReturn(dto)).data,
    getAllZimmets: async () => (await inventoryApi.getAllZimmets()).data,
    getMyZimmet: async () => (await inventoryApi.getMyZimmet()).data,
    getKasa: async () => (await inventoryApi.getKasa()).data,
    getZimmetReconciliation: async () => (await inventoryApi.getZimmetReconciliation()).data,
    getZimmetCanView: async () => (await inventoryApi.getZimmetCanView()).data,

    // Borç
    borcLend: async (context, dto) => (await inventoryApi.borcLend(dto)).data,
    borcReturn: async (context, dto) => (await inventoryApi.borcReturn(dto)).data,
    getBorclar: async (context, activeOnly) => (await inventoryApi.getBorclar(activeOnly)).data,

    // Diğer Satışlar
    otherSaleSell: async (context, dto) => (await inventoryApi.otherSaleSell(dto)).data,
    otherSaleRefund: async (context, dto) => (await inventoryApi.otherSaleRefund(dto)).data,
    getOtherSales: async (context, activeOnly) => (await inventoryApi.getOtherSales(activeOnly)).data,

    // Envanter tanımları (Takı/Külçe/Ziynet açılır listeleri)
    getDefinitions: async (context, { inventoryType, category } = {}) =>
        (await inventoryApi.getDefinitions(inventoryType, category)).data,
    createDefinition: async (context, dto) => (await inventoryApi.createDefinition(dto)).data,
    updateDefinition: async (context, { id, dto }) => (await inventoryApi.updateDefinition(id, dto)).data,
    deleteDefinition: async (context, id) => { await inventoryApi.deleteDefinition(id); },

    // Diğer Zimmet Kalemleri kataloğu
    getOtherItems: async () => (await inventoryApi.getOtherItems()).data,
    createOtherItem: async (context, dto) => (await inventoryApi.createOtherItem(dto)).data,
    updateOtherItem: async (context, { id, dto }) => (await inventoryApi.updateOtherItem(id, dto)).data,
    deleteOtherItem: async (context, id) => { await inventoryApi.deleteOtherItem(id); },

    // Ürün reçetesi (BOM)
    getProductComponents: async (context, productId) => (await inventoryApi.getProductComponents(productId)).data,
    saveProductComponents: async (context, { productId, items }) => { await inventoryApi.saveProductComponents(productId, items); },
    getTakiKinds: async () => (await inventoryApi.getTakiKinds()).data,
};

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    setTotalHas(state, totalHas) {
        state.totalHas = totalHas;
    },
    setJewelryItems(state, items) {
        state.jewelryItems = items;
    },
    setJewelryTotalHas(state, totalHas) {
        state.jewelryTotalHas = totalHas;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
